import { MyLensesSortDirection, SortBy } from "../../../gql-generated/types";

export interface Pagination {
    // TODO - remove since not used
    hasMore: boolean;
    limit: number;
    offset: number;
    sortBy: SortBy;
    sortDirection: MyLensesSortDirection;
}

export const defaultPagination: Readonly<Pagination> = {
    hasMore: false,
    limit: 20,
    offset: 0,
    sortBy: SortBy.SortByDate,
    sortDirection: MyLensesSortDirection.SortDirectionDesc,
};
